type Notification = {
  id?: number
  type: 'info' | 'error'
  title: string
  text: string
}

const DURATION = 50000

export function useNotification() {
  const notifications = useState<Notification[]>('notifications', () => [])

  function notify(notification: Notification) {
    notifications.value.push({
      id: Math.random(),
      ...notification,
    })
    setTimeout(dismiss, DURATION, notification)
  }

  function dismiss(notification: Notification) {
    notifications.value.splice(notifications.value.indexOf(notification), 1)
  }

  return {
    notifications,
    notify,
    dismiss,
  }
}
